module.exports = __webpack_public_path__ + "static/img/PVC page top img_desktop.b4ec0271.jpg";